import { jsx as _jsx } from "react/jsx-runtime";
import MuiToggleButton, {} from "@mui/material/ToggleButton";
export function ToggleButton(props) {
    return _jsx(MuiToggleButton, { ...props });
}
//# sourceMappingURL=ToggleButton.js.map